export default "__VITE_ASSET__f0f848d0__"